import { AfterViewInit, Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs';
import { ExpandLeft } from 'src/app/animations/ExpandLeft';
import { AuthService } from 'src/app/modules/auth/services/auth.service';
import { RouterService } from 'src/app/services/router-service.service';
import { HeaderService } from '../../services/headerservice';

@Component({
	selector: 'app-upper-header',
	templateUrl: './upper-header.component.html',
	styleUrls: ['./upper-header.component.scss'],
	animations: [ExpandLeft]
})
export class UpperHeaderComponent implements AfterViewInit {

	search : FormControl;
	bLoggedIn! : boolean;
	disableAnimationOnStartup = true;

	constructor(public routerService:RouterService,
				private auth:AuthService,
				private headerService:HeaderService,
				private router:Router,
				private activatedRoute:ActivatedRoute) {
		this.auth.oUser.subscribe((u)=> {
			if (u)
				this.bLoggedIn = true;
			else
				this.bLoggedIn = false;
		});

		this.search = new FormControl(undefined);

		// Subscripción a cambios en la url. Si esta dirección no es la de la página de productos, se limpia el input
		// Si no lo limpio queda con el valor indefinidamente mientras el usuario anda por el resto de la página
		this.router.events.pipe(filter(event => event instanceof NavigationStart)).subscribe(v=> {
			let a : NavigationStart = <NavigationStart>v;
			if (!a.url.includes(this.routerService.SEARCH)) {
				setTimeout(() => {
					this.search.reset();
				}, 150);
			}
		});

		this.headerService.oClearSearchInput.subscribe(()=> {
			this.search.reset();
		});
	}

	ngAfterViewInit(): void {
		let i = this.activatedRoute.snapshot.queryParams["i"];
		setTimeout(() => {
			this.disableAnimationOnStartup = false;

			// Esto es porque si se entra a la página con un "i" ya seteado, lo agarro para ponerlo en el input
			if (i)
				this.search.patchValue(i);
		}, 0);
	}

	onSearch() {
		if (this.routerService.currentRoute.includes(this.routerService.SEARCH) || this.routerService.currentRoute.includes(this.routerService.STORE)) {
			this.routerService.addQueryParametersToCurrentRoute({i: this.search.value})
		} else {
			this.routerService.toSearch(this.search.value)
		}
	}
}
